import React from 'react'
import _ from 'underscore'
import Link from '../../helper/link'

import LegacyNavigatorWrapper from '../../helper/legacyNavigatorWrapper'
import { paginate } from '../../paginate'

interface Props {
    totalPages: number
    currentPage: number
    navigator: LegacyNavigatorWrapper
}
class Pager extends React.Component<Props> {
    public render() {
        const totalPages = this.props.totalPages
        const currentPage = this.props.currentPage
        let previousPage = 0

        return (
            <ul className="pagination pagination-sm" style={{ marginRight: '10px' }}>
                {_.map(paginate(totalPages, currentPage), page => {
                    const listElements: JSX.Element[] = []

                    if (page - previousPage > 1) {
                        listElements.push(
                            <li key="others" className="disabled">
                                <a>…</a>
                            </li>,
                        )
                    }
                    previousPage = page

                    listElements.push(
                        <li key={page} className={page === currentPage ? 'active' : ''}>
                            <Link {...this.props.navigator.linkTo({ page })} title={'Page ' + page}>
                                {page}
                            </Link>
                        </li>,
                    )

                    return listElements
                })}
            </ul>
        )
    }
}

export default Pager
